import { MONTHS_IN_YEAR } from "web_myplann/Shared/constants";
import { getFutureValueFactor } from "web_myplann/Shared/Utils/getFutureValueFactor";

export const futureValueOfMonthlySavings = (
	monthlyAmount: number,
	annualRate: number,
	months: number,
): number => {
	if (monthlyAmount <= 0 || months <= 0) return 0;
	return (
		monthlyAmount * getFutureValueFactor(annualRate / MONTHS_IN_YEAR, months)
	);
};
